<template>
    <v-card class="default_card_wm ma-4" style="min-width: 98%" elevation="0">
        <!-- Dans la gestion interne -->
        <v-row no-gutters class="ma-5 fill-height">
            <v-col cols="12">
                <v-row no-gutters>
                    <!--Header row-->
                    <v-col cols="1">
                        <v-btn-back data-cy="UserEdition-back" @click="back()" />
                    </v-col>
                    <v-col cols="4">
                        <h1>{{ getUserDisplayName(user) }}</h1>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                        <v-select-filled
                            v-model="user.type"
                            :items="typesList"
                            item-value="value"
                            :item-title="(item: any) => item.text"
                            outlined
                            hide-details
                            class="mx-1"
                            :disabled="userIsSubUser"
                            @update:model-value="onChangeType()"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="2" class="d-flex justify-end">
                        <v-switch
                            v-if="user.type === 'NATURAL_PERSON'"
                            v-model="isUserWithAccount"
                            label="Activer le compte"
                            data-cy="UserEdition-isUserWithAccount-switch"
                            class="pa-0"
                            density="compact"
                            :disabled="userIsSubUser"
                        />
                    </v-col>
                    <v-col :cols="isDeletableUser ? 2 : 3" class="d-flex justify-end align-center">
                        <v-btn
                            class="elevation-0 mx-1"
                            rounded="xl"
                            v-if="!isAccountingCurrentUser && !isLegalPerson && !user.email"
                            @click="forcedWithAccountUser = true"
                            size="small"
                        >
                            Créer un compte
                        </v-btn>
                        <v-btn
                            class="elevation-0 mx-1"
                            rounded="xl"
                            :disabled="!isValid"
                            :loading="upsertLoading"
                            @click="upsert()"
                            data-cy="UserEdition-update"
                            size="small"
                        >
                            {{ user.id ? "Mettre à jour" : "Créer" }}
                        </v-btn>
                    </v-col>
                    <!-- <v-col cols="1" class="d-flex justify-end align-center" v-if="isDeletableUser">
                        <v-btn-trash @click="deleteUser()" />
                    </v-col> -->
                </v-row>
                <v-row no-gutters>
                    <!--Content row-->
                    <v-col cols="3" style="border-right: 1px #eaeaea solid">
                        <v-list dense nav v-model="selectedMenu">
                            <v-list-item
                                link
                                value="information"
                                @click="setSelectedMenu('information')"
                                id="Information"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$person" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-informations">
                                    <span class="subtitle-2">Informations</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="personnal-information"
                                @click="setSelectedMenu('personnal-information')"
                                id="Complementaires"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$person" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-furtherInformation">
                                    <span class="subtitle-2">Informations complémentaires</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="bankAccount-information"
                                @click="setSelectedMenu('bankAccount-information')"
                                id="BankAccount"
                                v-if="showIban"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$fa-university" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-BankAccount">
                                    <span class="subtitle-2">Informations bancaires</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="profil"
                                @click="setSelectedMenu('profil')"
                                v-if="user.type === 'NATURAL_PERSON'"
                                id="Profil"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$person" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-roleSociety">
                                    <span class="subtitle-2">{{
                                        isFromUsersMenu
                                            ? "Rôle dans la société"
                                            : "Rôle dans le dossier"
                                    }}</span>
                                </v-list-item-title>
                            </v-list-item>

                            <v-list-item
                                link
                                value="available-accounting-firms"
                                @click="setSelectedMenu('available-accounting-firms')"
                                v-if="
                                    isAccountingCurrentUser && isAccountingUser && isUserWithAccount
                                "
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$fa-building" />
                                </template>
                                <v-list-item-title>
                                    <span class="subtitle-2">Cabinets affectés</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="available-accounting-workspaces"
                                @click="setSelectedMenu('available-accounting-workspaces')"
                                v-if="
                                    isAccountingCurrentUser && isAccountingUser && enableWorkspace
                                "
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$fa-building" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-dossierGroup">
                                    <span class="subtitle-2">Groupe de dossiers affectés</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="other-companies"
                                @click="setSelectedMenu('other-companies')"
                                v-if="isAccountingCurrentUser"
                                id="Other companies"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$fa-building" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-other-companies">
                                    <span class="subtitle-2">Autre(s) sociétés</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="available-companies"
                                @click="setSelectedMenu('available-companies')"
                                v-if="
                                    isAccountingCurrentUser &&
                                    (isUserWithAccount || user.type === 'API_USER')
                                "
                                id="Societe"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$fa-building" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-companiesAffected">
                                    <span class="subtitle-2">Dossiers affectés</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                link
                                value="investment"
                                @click="setSelectedMenu('investment')"
                                v-if="!!user.id"
                                id="Investment"
                            >
                                <template #prepend style="height: none">
                                    <v-icon size="small" icon="$person" />
                                </template>
                                <v-list-item-title data-cy="UserEdition-associateParameters">
                                    <span class="subtitle-2">Associé</span>
                                </v-list-item-title>
                            </v-list-item></v-list
                        >
                    </v-col>
                    <v-col cols="9" class="pl-3">
                        <v-window v-model="selectedMenu">
                            <v-window-item value="information">
                                <v-form v-model="formIsValid" v-if="!isLegalPerson">
                                    <v-row no-gutters class="pt-2">
                                        <v-col
                                            cols="4"
                                            v-if="isUserWithAccount || user.type === 'API_USER'"
                                        >
                                            <v-select-filled
                                                v-model="profileId"
                                                :items="availableProfiles"
                                                :item-title="getProfileName"
                                                item-value="id"
                                                label="Profil utilisateur"
                                                outlined
                                                hide-details="auto"
                                                :rules="[
                                                    (p) =>
                                                        (!!p && !!p.length) ||
                                                        'Sélectionnez un profil',
                                                ]"
                                                v-if="availableProfiles && availableProfiles.length"
                                                density="compact"
                                                data-cy="UserEdition-selectProfile"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pr-2" v-else>
                                            <v-text-field-filled
                                                outlined
                                                readonly
                                                hide-details
                                                type="text"
                                                :disabled="userIsSubUser"
                                                :label="isFromUsersMenu ? 'Société' : 'Dossier'"
                                                v-model="user.company.name"
                                                data-cy="UserEdition-companyName"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                v-model="user.firstname"
                                                type="text"
                                                label="Prénom"
                                                outlined
                                                hide-details="auto"
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-userFirstname"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                v-model="user.lastname"
                                                type="text"
                                                label="Nom"
                                                outlined
                                                :disabled="userIsSubUser"
                                                hide-details="auto"
                                                :rules="[(v) => !!v || 'Un nom est requis']"
                                                data-cy="UserEdition-userLastname"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                v-model="user.marriedName"
                                                type="text"
                                                label="Nom marital"
                                                outlined
                                                :disabled="userIsSubUser"
                                                hide-details="auto"
                                                data-cy="UserEdition-userMarriedName"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2" v-if="isUserWithAccount">
                                        <!-- <v-col cols="4" class="pr-2">
                                            <v-text-field
                                                v-model="user.email"
                                                type="text"
                                                outlined
                                                dense
                                                :disabled="userIsSubUser"
                                                hide-details="auto"
                                                label="Email"
                                                :rules="[
                                                    (email) => emailPattern.test(email) || 'Un email est requis',
                                                    (email) => !alreadyExistEmails[email] || 'L\'email existe déjà'
                                                ]"
                                            ></v-text-field>
                                        </v-col> -->
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                v-if="userIsSubUser"
                                                type="text"
                                                outlined
                                                hide-details="auto"
                                                label="Email"
                                                disabled
                                                :model-value="getDisplayEmail(user.email)"
                                                density="compact"
                                                data-cy="UserEdition-accountEmail"
                                            />
                                            <v-text-field-filled
                                                v-else
                                                data-cy="UserEdition-email"
                                                v-model="user.email"
                                                type="text"
                                                outlined
                                                hide-details="auto"
                                                label="Email"
                                                :rules="[
                                                    (email) =>
                                                        emailPattern.test(email) ||
                                                        'Un email est requis',
                                                    (email) =>
                                                        !alreadyExistEmails[email] ||
                                                        'L\'email existe déjà',
                                                ]"
                                            >
                                                <!-- <template v-slot:append>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, props }">
                                                            <v-icon
                                                                size="small"
                                                                v-if="!user.emailVerified"
                                                                v-bind="props"
                                                                v-on="on"
                                                                @click="resendSignupEmail"
                                                            >
                                                                fas fa-redo
                                                            </v-icon>
                                                        </template>
                                                        <span>Générer un nouveau mail de connexion</span>
                                                    </v-tooltip>
                                                </template> -->
                                            </v-text-field-filled>
                                        </v-col>
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                outlined
                                                readonly
                                                hide-details
                                                type="text"
                                                :label="isFromUsersMenu ? 'Société' : 'Dossier'"
                                                :disabled="userIsSubUser"
                                                v-model="user.company.name"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" v-if="displayPasswordInput">
                                            <v-text-field-filled
                                                outlined
                                                :required="!user.id"
                                                label="Mot de passe"
                                                :type="displayPassword ? 'text' : 'password'"
                                                :append-inner-icon="
                                                    displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                                "
                                                v-model="password"
                                                v-if="isPasswordRequired"
                                                :rules="[
                                                    (p) =>
                                                        !p ||
                                                        !p.length ||
                                                        p.length >= 4 ||
                                                        'Mot de passe requis (4 caractères minimum)',
                                                ]"
                                                :disabled="userIsSubUser"
                                                hide-details="auto"
                                                density="compact"
                                                @click:append-inner="
                                                    displayPassword = !displayPassword
                                                "
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="pt-2"
                                        v-if="isUserWithAccount && user.externalId"
                                    >
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                outlined
                                                dense
                                                hide-details
                                                readonly
                                                type="text"
                                                label="Identifiant externe"
                                                v-model="user.externalId"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                        class="d-flex justify-end pt-2"
                                        v-if="isPasswordRequired && displayPasswordInput"
                                    >
                                        <v-col cols="4">
                                            <v-text-field-filled
                                                outlined
                                                :required="!user.id"
                                                hide-details="auto"
                                                label="Confirmer le mot de passe"
                                                :type="displayPassword ? 'text' : 'password'"
                                                :append-inner-icon="
                                                    displayPassword ? '$oss-eye' : '$oss-eye-slash'
                                                "
                                                :disabled="userIsSubUser"
                                                v-model="confirmPassword"
                                                :rules="[
                                                    (p) =>
                                                        p === password ||
                                                        'Le mot de passe de correspond pas',
                                                ]"
                                                density="compact"
                                                @click:append-inner="
                                                    displayPassword = !displayPassword
                                                "
                                            />
                                        </v-col>
                                    </v-row>
                                    <!-- <template v-if="showIban">
                                        <v-divider class="my-1"></v-divider>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="selectedBankAccount.iban"
                                                    label="IBAN"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :rules="[rules.notEmpty, rules.checkIBAN]"
                                                    @change="onIbanChanged(selectedBankAccount)"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="selectedBankAccount.bic"
                                                    label="BIC"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :rules="[rules.notEmpty, rules.checkBIC]"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </template> -->
                                </v-form>
                                <v-form v-model="formIsValid" v-else>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="8" class="pr-2">
                                            <v-text-field-filled
                                                v-model="user.lastname"
                                                type="text"
                                                label="Nom de la société"
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                :rules="[
                                                    (v) =>
                                                        !!v || 'Le nom de l\'entreprise est requis',
                                                ]"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                outlined
                                                hide-details
                                                type="text"
                                                :label="isFromUsersMenu ? 'Société' : 'Dossier'"
                                                disabled
                                                v-model="user.company.name"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="pt-2">
                                        <v-col cols="5" class="pr-2">
                                            <v-autocomplete-filled
                                                v-model="user.legalForm"
                                                :items="legalForms"
                                                :item-title="formatItemTitle"
                                                item-value="id"
                                                :disabled="userIsSubUser"
                                                label="Forme juridique"
                                            />
                                        </v-col>
                                        <v-col cols="3" class="pr-2">
                                            <v-text-field-filled
                                                v-model="user.siret"
                                                type="text"
                                                label="SIRET"
                                                :rules="rulesSiret"
                                                @input="onInputSetTruncatedSiret()"
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                    <!-- <template v-if="showIban">
                                        <v-divider class="my-1"></v-divider>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="selectedBankAccount.iban"
                                                    label="IBAN"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :rules="[rules.notEmpty, rules.checkIBAN]"
                                                    @change="onIbanChanged(selectedBankAccount)"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    v-model="selectedBankAccount.bic"
                                                    label="BIC"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    :rules="[rules.notEmpty, rules.checkBIC]"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </template> -->
                                </v-form>
                            </v-window-item>
                            <v-window-item value="profil">
                                <ProfileEdition
                                    ref="profileEdition"
                                    :company="user.company"
                                    :user="user"
                                    :isAccountActivated="isUserWithAccount"
                                />
                            </v-window-item>
                            <v-window-item value="investment" style="min-width: 100%">
                                <AssociateEdition
                                    v-model="user"
                                    ref="investmentEdition"
                                    :company="user.company"
                                    :legalForm="legalForm"
                                />
                            </v-window-item>
                            <v-window-item value="bankAccount-information">
                                <v-row>
                                    <v-col cols="6">
                                        <span class="title ml-2"
                                            >Informations bancaires pour le paiement</span
                                        >
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field-filled
                                            v-model="selectedBankAccount.name"
                                            label="Nom de la banque"
                                            outlined
                                            hide-details
                                            :rules="[rules.notEmpty]"
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-bankName"
                                            density="compact"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field-filled
                                            v-model="selectedBankAccount.iban"
                                            label="IBAN"
                                            outlined
                                            hide-details
                                            :rules="[
                                                rules.checkIBAN,
                                                (v) =>
                                                    v.length <= 34 ||
                                                    'IBAN must be 34 characters or less',
                                            ]"
                                            @change="onIbanChanged(selectedBankAccount)"
                                            @input="onInputSetTruncatedIban()"
                                            maxlength="34"
                                            density="compact"
                                            data-cy="UserEdition-IBAN"
                                        />
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field-filled
                                            v-model="selectedBankAccount.bic"
                                            label="BIC"
                                            outlined
                                            hide-details
                                            :rules="[rules.notEmpty, rules.checkBIC]"
                                            :disabled="userIsSubUser"
                                            density="compact"
                                            data-cy="UserEdition-BIC"
                                        />
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="personnal-information">
                                <template v-if="!isLegalPerson">
                                    <v-row no-gutters class="py-2">
                                        <v-col cols="2" class="d-flex align-center">
                                            <v-radio-group
                                                v-model="user.civility"
                                                inline
                                                density="compact"
                                                hide-details
                                                class="mt-0"
                                                :disabled="userIsSubUser"
                                                color="primary"
                                            >
                                                <v-radio
                                                    :ripple="false"
                                                    label="M"
                                                    value="MR"
                                                    data-cy="UserEdition-M"
                                                />
                                                <v-radio
                                                    :ripple="false"
                                                    label="Mme"
                                                    value="MS"
                                                    data-cy="UserEdition-Mme"
                                                />
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="3" class="pl-2">
                                            <v-text-field-filled
                                                v-model="user.phoneNumber"
                                                label="Numéro de téléphone"
                                                required
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-tel"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="3" class="pl-2">
                                            <v-text-field-filled
                                                v-if="userIsSubUser"
                                                type="text"
                                                outlined
                                                hide-details="auto"
                                                label="Email"
                                                disabled
                                                :model-value="
                                                    getDisplayEmail(user.emailSubscription)
                                                "
                                                data-cy="UserEdition-contactEmail"
                                                density="compact"
                                            />
                                            <v-text-field-filled
                                                v-else
                                                v-model="user.emailSubscription"
                                                type="text"
                                                outlined
                                                hide-details="auto"
                                                label="Email de contact"
                                                data-cy="UserEdition-contactEmail"
                                            >
                                            </v-text-field-filled>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col class="d-flex align-center col-auto pr-2">
                                            Naissance
                                        </v-col>
                                        <v-col class="d-flex align-center">
                                            <v-divider />
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters class="py-2">
                                        <v-col cols="2">
                                            <oss-date-picker-filled
                                                v-model="user.birthDate"
                                                :hide-details="true"
                                                label="Date"
                                                :text-field-read-only="false"
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-birthday"
                                            />
                                        </v-col>
                                        <v-col cols="3" class="pl-2">
                                            <v-text-field-filled
                                                v-model="user.birthDepartment"
                                                label="Département"
                                                required
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-birthDepartment"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="3" class="pl-2">
                                            <v-text-field-filled
                                                v-model="user.birthPlace"
                                                label="Commune"
                                                required
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-birthPlace"
                                                density="compact"
                                            />
                                        </v-col>
                                        <v-col cols="3" class="pl-2">
                                            <OssCountrySelector
                                                v-model="user.birthCountry"
                                                required
                                                :disabled="userIsSubUser"
                                                data-cy="UserEdition-birthCountry"
                                            >
                                            </OssCountrySelector>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else>
                                    <v-row no-gutters class="py-2">
                                        <v-col cols="3">
                                            <v-text-field-filled
                                                v-model="user.phoneNumber"
                                                label="Numéro de téléphone"
                                                required
                                                outlined
                                                hide-details
                                                :disabled="userIsSubUser"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                </template>
                                <v-row no-gutters>
                                    <v-col class="d-flex align-center col-auto pr-2">
                                        Adresse
                                    </v-col>
                                    <v-col class="d-flex align-center">
                                        <v-divider />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="5" class="d-flex pr-2">
                                        <v-text-field-filled
                                            v-model="user.address"
                                            :label="$t('settings.address')"
                                            :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                            required
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-address"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="d-flex pr-2">
                                        <v-text-field-filled
                                            v-model="user.addressComplement"
                                            :label="$t('settings.addressComplement')"
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-addressComplement"
                                            density="compact"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="py-2">
                                    <v-col cols="2" class="d-flex pr-2">
                                        <v-text-field-filled
                                            v-model="user.postalCode"
                                            :label="$t('settings.postalCode')"
                                            :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                            required
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-codePostal"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="d-flex pr-2">
                                        <v-text-field-filled
                                            v-model="user.city"
                                            :label="$t('settings.city')"
                                            :rules="[(v) => !!v || $t('settings.itemRequired')]"
                                            required
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-city"
                                            density="compact"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="d-flex pr-2">
                                        <OssCountrySelector
                                            v-model="user.country"
                                            required
                                            :disabled="userIsSubUser"
                                            data-cy="UserEdition-country"
                                        >
                                        </OssCountrySelector>
                                    </v-col>
                                </v-row>
                                <template v-if="gainOrLossReadRight">
                                    <v-divider />
                                    <v-row no-gutters class="py-2">
                                        <v-col cols="4" class="pr-2">
                                            <v-text-field-filled
                                                v-model.number="user.hourlyCost"
                                                outlined
                                                label="Coût horaire"
                                                :disabled="userIsSubUser || !gainOrLossWriteRight"
                                                density="compact"
                                            />
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-window-item>
                            <v-window-item value="available-companies">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="8" class="pr-2">
                                        <v-text-field-filled
                                            v-model="searchCompany"
                                            label="Rechercher"
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            density="compact"
                                            append-inner-icon="$search"
                                            clearable
                                            @click:clear="searchCompany = ''"
                                        />
                                    </v-col>
                                    <v-col class="d-flex align-center">
                                        <v-btn-add
                                            size="small"
                                            class="ml-2 text-center"
                                            @click="openClientCompaniesDialog"
                                        >
                                        </v-btn-add>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pt-2">
                                    <template v-if="!mySelectedCompanies.length">
                                        Aucun dossier trouvé
                                    </template>
                                    <v-col
                                        cols="6"
                                        v-for="comp in mySelectedCompanies"
                                        :key="comp.id"
                                        class="pr-2 pb-2"
                                    >
                                        <v-list-item
                                            class="oss-list-item"
                                            @click="onCompanySelectFromMainList(comp)"
                                        >
                                            <template #prepend>
                                                <v-icon
                                                    :color="
                                                        hasRight(comp)
                                                            ? isAvailableCompanies(comp.id)
                                                                ? 'primary'
                                                                : 'secondary'
                                                            : 'grey'
                                                    "
                                                    :disabled="currentUserIsSubUser"
                                                    location="start"
                                                >
                                                    {{
                                                        isAvailableCompanies(comp.id)
                                                            ? "$check_box"
                                                            : "$check_box_outline_blank"
                                                    }}
                                                </v-icon>
                                            </template>
                                            <v-list-item-title>
                                                <span>{{ comp.name }}</span
                                                ><v-chip
                                                    label
                                                    color="primary"
                                                    v-if="isOwner(user, comp)"
                                                    class="ml-2"
                                                    size="small"
                                                    variant="outlined"
                                                    >Propriétaire</v-chip
                                                >
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ getSiretValue(comp.siret) }}
                                            </v-list-item-subtitle>
                                            <template #append>
                                                <v-btn-icon
                                                    icon="$fa-user-cog"
                                                    :color="hasRight(comp) ? 'primary' : 'grey'"
                                                    @click.stop="setCompanySettings(comp)"
                                                />
                                            </template>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="other-companies">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="8" class="pr-2">
                                        <v-text-field-filled
                                            v-model="searchCompany"
                                            label="Rechercher"
                                            outlined
                                            hide-details
                                            :disabled="userIsSubUser"
                                            density="compact"
                                            append-inner-icon="$search"
                                            clearable
                                            @click:clear="searchCompany = ''"
                                        />
                                    </v-col>
                                    <v-col class="d-flex align-center">
                                        <v-btn-add
                                            size="small"
                                            class="ml-2 text-center"
                                            @click="openOtherClientCompaniesDialog"
                                        >
                                        </v-btn-add>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pt-2">
                                    <template v-if="!myOtherCompanies.length">
                                        Aucune société trouvée
                                    </template>
                                    <v-col
                                        cols="6"
                                        v-for="userCompany in myOtherCompanies"
                                        :key="userCompany.id"
                                        class="pr-2 pb-2"
                                    >
                                        <v-list-item
                                            class="oss-list-item"
                                            @click="onOtherCompanyClicked(userCompany)"
                                        >
                                            <template #prepend>
                                                <v-icon :color="'primary'" location="start"
                                                    >{{
                                                        userCompany.partOfCompany
                                                            ? "$check_box"
                                                            : "$check_box_outline_blank"
                                                    }}
                                                </v-icon>
                                            </template>
                                            <v-list-item-title>
                                                <span>{{ userCompany.company.name }}</span>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                {{ getSiretValue(userCompany.company.siret) }}
                                            </v-list-item-subtitle>
                                            <template #append>
                                                <v-btn-icon
                                                    icon="$fa-user-cog"
                                                    @click.stop="
                                                        setCompanySettings(userCompany.company)
                                                    "
                                                />
                                            </template>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="available-accounting-firms">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="8" class="pr-2">
                                        <v-text-field-filled
                                            v-model="searchAccountingFirm"
                                            label="Rechercher"
                                            outlined
                                            hide-details
                                            density="compact"
                                            append-inner-icon="$search"
                                            clearable
                                            @click:clear="searchAccountingFirm = ''"
                                        />
                                    </v-col>
                                    <v-col class="d-flex align-center">
                                        <v-btn-add
                                            size="small"
                                            class="ml-2 text-center"
                                            @click="openAccountingFirmsDialog"
                                        >
                                        </v-btn-add>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pt-2">
                                    <template v-if="!mySelectedAccountingFirms.length">
                                        Aucun cabinet trouvé
                                    </template>
                                    <v-col cols="12" class="mb-2">
                                        <!-- <v-btn
                                            color="primary"
                                            elevation="0"
                                            class="mr-2"
                                            rounded
                                            size="small"
                                            @click="selectAllAccountingFirms()"
                                        >
                                            Sélectionner tous les cabinets
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            elevation="0"
                                            rounded
                                            size="small"
                                            @click="diselectAllAccountingFirms()"
                                        >
                                            Désélectionner tous les cabinets
                                        </v-btn> -->
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        v-for="comp in mySelectedAccountingFirms"
                                        :key="comp.id"
                                        class="pr-2 pb-2"
                                    >
                                        <v-list-item
                                            ripple
                                            class="oss-list-item"
                                            :disabled="userIsSubUser"
                                        >
                                            <template #prepend>
                                                <v-checkbox
                                                    v-model="userAccountingFirmIds"
                                                    :value="comp.id"
                                                    :disabled="
                                                        userIsSubUser ||
                                                        isParentAccountingFirm(comp.id)
                                                    "
                                                    @click="
                                                        onAccountingFirmSelectFromMainList(comp.id)
                                                    "
                                                />
                                            </template>
                                            <v-list-item-title>
                                                <span>{{
                                                    comp.name +
                                                    (isParentAccountingFirm(comp.id)
                                                        ? " (Cabinet principale)"
                                                        : "")
                                                }}</span>
                                                <!-- <v-chip  size="small" label outlined color="primary" v-if="isOwner(user,comp)" class="ml-2">Propriétaire</v-chip> -->
                                            </v-list-item-title>
                                            <v-list-item-subtitle v-if="comp.siret">
                                                {{ getSiretValue(comp.siret) }}
                                            </v-list-item-subtitle>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                            <v-window-item value="available-accounting-workspaces">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="8" class="pr-2">
                                        <v-text-field-filled
                                            v-model="searchAccountingWorkspace"
                                            label="Rechercher"
                                            outlined
                                            hide-details
                                            density="compact"
                                            append-inner-icon="$search"
                                            clearable
                                            @click:clear="searchAccountingWorkspace = ''"
                                            data-cy="userEdition-searchAccountingWorkspace"
                                        />
                                    </v-col>
                                    <v-col class="d-flex align-center">
                                        <v-btn-add
                                            size="small"
                                            class="ml-2 text-center"
                                            @click="openAccWorkspacesDialog()"
                                            data-cy="userEdition-addAccountingWorkspace"
                                        >
                                        </v-btn-add>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="pt-2">
                                    <template v-if="!mySelectedAccWorkspaces.length">
                                        Aucun groupe de dossiers trouvé
                                    </template>
                                    <!-- <v-col cols="12" class="mb-2">
                                        <v-btn
                                            color="primary"
                                            elevation="0"
                                            class="mr-2"
                                            rounded
                                            size="small"
                                            @click="selectAllAccountingWorkspaces()"
                                        >
                                            Sélectionner tous les groupes
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            elevation="0"
                                            rounded
                                            size="small"
                                            @click="diselectAllAccountingWorkspaces()"
                                        >
                                            Désélectionner tous les groupes
                                        </v-btn>
                                    </v-col> -->
                                    <v-col
                                        cols="6"
                                        v-for="aW in mySelectedAccWorkspaces"
                                        :key="aW.id"
                                        class="pr-2 pb-2"
                                    >
                                        <v-list-item
                                            ripple
                                            class="oss-list-item"
                                            :disabled="currentUserIsSubUser"
                                            data-cy="userEdition-addedAccountingWorkspace"
                                        >
                                            <template #prepend>
                                                <v-checkbox
                                                    v-model="accountingWorkspacesOfUser"
                                                    :disabled="currentUserIsSubUser"
                                                    @click="onWorkspaceSelectFromMainList(aW.id)"
                                                    :value="aW.id"
                                                />
                                            </template>
                                            <v-list-item-title>
                                                <span>{{ aW.name || "XXX" }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-window-item>
                        </v-window>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <!-- <oss-dialog
            v-model="dialogSelectCompany"
            :title="'Choisir une société'"
            v-if="dialogSelectCompany"
            data-cy="UserEdition-create"
            width="1000px"
        >
            <company-table
                v-model="user.company"
                :showGenericCompany="false"
                :showNewCompanies="false"
                :select-company="dialogSelectCompany = false"
            />
        </oss-dialog> -->
        <!-- <oss-dialog
            v-model="dialogDisconnectUser"
            :title="'Retirer les droits de connexion'"
            @valid="deleteUser"
            :validTitle="'Retirer les droits des connexion de cet utilisateur'"
            width="1000px"
        >
            <v-row class="mx-2">
                <v-col>
                    Vous êtes sur le point de retirer le droits de connexion de
                    <b>{{ getUserDisplayName(user) }}</b> à la plateforme. Cet utilisateur ne sera
                    pas supprimer de votre société mais ne pourra plus se connecter.
                </v-col>
            </v-row>
        </oss-dialog> -->
        <oss-dialog
            v-model="companySettingDialog"
            :title="titleCompanySetting"
            :actions="profileEditionActions"
            width="60vw"
        >
            <v-tabs
                v-model="profileEditionTab"
                fixed-tabs
                style="
                    background-color: transparent !important;
                    border-radius: 16px;
                    overflow: hidden;
                "
            >
                <v-tab value="profileEdition" href="#profileEdition">
                    <strong>{{
                        isFromUsersMenu ? "Rôle dans la société" : "Rôle dans le dossier"
                    }}</strong>
                </v-tab>
                <v-tab value="associateEdition" href="#associateEdition">
                    <strong>Associé</strong>
                </v-tab>
            </v-tabs>

            <v-tabs-window v-model="profileEditionTab">
                <v-window-item value="profileEdition">
                    <ProfileEdition
                        :user="user"
                        :company="companySettingSelected"
                        :actions="profileEditionActions"
                        :isAccountActivated="isUserWithAccount"
                        @upserted="
                            companySettingDialog = false;
                            profileEditionTab = 'profileEdition';
                        "
                        v-if="companySettingDialog"
                    />
                </v-window-item>
                <v-window-item value="associateEdition">
                    <AssociateEdition
                        :company="companySettingSelected"
                        v-model="user"
                        :legalForm="legalForm"
                        @upserted="
                            companySettingDialog = false;
                            profileEditionTab = 'profileEdition';
                        "
                        v-if="companySettingDialog"
                    />
                </v-window-item>
            </v-tabs-window>
        </oss-dialog>

        <oss-dialog
            v-model="showClientCompaniesDialog"
            title="Ajouter des dossiers"
            @valid="onValidateCompaniesDialog"
            width="80vw"
        >
            <v-row no-gutters class="pt-0 selection">
                <div class="sticky-selection-header">
                    <v-row no-gutters>
                        <v-col cols="8" class="mt-2 mb-3">
                            <v-text-field-filled
                                v-model="searchCompany"
                                label="Rechercher"
                                outlined
                                hide-details
                                :disabled="userIsSubUser"
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchCompany = ''"
                            />
                        </v-col>
                    </v-row>

                    <v-row
                        no-gutters
                        cols="12"
                        class="mb-2"
                        v-if="workingFilteredClientCompanies.length"
                    >
                        <v-btn
                            elevation="0"
                            class="mr-2"
                            rounded="xl"
                            @click="selectAllCompany()"
                            data-cy="UserEdition-allCompanies"
                            size="small"
                        >
                            Sélectionner tous les dossiers
                        </v-btn>
                        <v-btn
                            elevation="0"
                            rounded="xl"
                            @click="diselectAllCompany()"
                            data-cy="UserEdition-notAllCompanies"
                            size="small"
                        >
                            Désélectionner tous les dossiers
                        </v-btn>
                    </v-row>
                </div>
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        class="text-center py-3"
                        v-if="!workingFilteredClientCompanies.length"
                    >
                        <span>Aucun dossier trouvé</span>
                    </v-col>
                    <template v-for="comp in workingFilteredClientCompanies" :key="comp.id">
                        <v-col cols="6" class="pr-2 pb-2" v-if="!isAvailableCompanies(comp.id)">
                            <v-list-item ripple class="oss-list-item">
                                <template #prepend>
                                    <v-checkbox
                                        v-model="selectedClientCompanies"
                                        :value="comp"
                                        color="primary"
                                        :value-comparator="(a: any, b: any) => a.id === b.id"
                                        :disabled="currentUserIsSubUser || !hasRight(comp)"
                                    />
                                </template>
                                <v-list-item-title>
                                    <span>{{ comp.name }}</span
                                    ><v-chip
                                        size="small"
                                        label
                                        color="primary"
                                        v-if="isOwner(user, comp)"
                                        class="ml-2"
                                        variant="outlined"
                                        >Propriétaire</v-chip
                                    >
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ getSubTitleCompany(comp) }}
                                </v-list-item-subtitle>
                                <template v-if="isInInternalManagement" #append>
                                    <v-btn-icon
                                        variant="tonal"
                                        size="small"
                                        icon="$fa-user-cog"
                                        :color="hasRight(comp) ? 'primary' : 'grey'"
                                        @click.stop="setCompanySettings(comp)"
                                    />
                                </template>
                            </v-list-item>
                        </v-col>
                    </template>
                </v-row>
            </v-row>
        </oss-dialog>

        <oss-dialog
            v-model="showOtherCompaniesDialog"
            title="Associer à d'autres sociétés"
            @valid="onValidateOtherCompaniesDialog"
            width="80vw"
        >
            <v-row no-gutters class="pt-0 selection">
                <div class="sticky-selection-header">
                    <v-row no-gutters>
                        <v-col cols="8" class="mt-2 mb-3">
                            <v-text-field-filled
                                v-model="searchCompany"
                                label="Rechercher"
                                outlined
                                hide-details
                                :disabled="userIsSubUser"
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchCompany = ''"
                            />
                        </v-col>
                    </v-row>
                </div>
                <v-row no-gutters>
                    <v-col
                        cols="12"
                        class="text-center py-3"
                        v-if="!workingFilteredClientCompanies.length"
                    >
                        <span>Aucun dossier trouvé</span>
                    </v-col>
                    <template v-for="comp in workingFilteredClientCompanies" :key="comp.id">
                        <v-col
                            cols="6"
                            class="pr-2 pb-2"
                            v-if="!isAlreadyOtherCompany(comp.id) && user.company.id !== comp.id"
                        >
                            <v-list-item ripple class="oss-list-item">
                                <template #prepend>
                                    <v-checkbox
                                        v-model="selectedOtherCompanies"
                                        :value="comp"
                                        color="primary"
                                        :value-comparator="(a: any, b: any) => a.id === b.id"
                                    />
                                </template>
                                <v-list-item-title>
                                    <span>{{ comp.name }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ getSubTitleCompany(comp) }}
                                </v-list-item-subtitle>
                            </v-list-item>
                        </v-col>
                    </template>
                </v-row>
            </v-row>
        </oss-dialog>

        <oss-dialog
            v-model="showAccWorkspacesDialog"
            title="Ajouter des groupes de dossiers"
            @valid="onValidateAccWorkspacesDialog()"
            width="80vw"
        >
            <v-container no-gutters class="pt-0 selection">
                <div class="sticky-selection-header">
                    <v-row no-gutters class="py-2">
                        <v-col cols="8" class="pr-2">
                            <v-text-field-filled
                                v-model="searchAccountingWorkspace"
                                label="Rechercher"
                                outlined
                                hide-details
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchAccountingWorkspace = ''"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-btn
                            elevation="0"
                            class="mr-2"
                            rounded="xl"
                            @click="selectAllAccountingWorkspaces()"
                            size="small"
                        >
                            Sélectionner tous les groupes
                        </v-btn>
                        <v-btn
                            elevation="0"
                            rounded="xl"
                            @click="diselectAllAccountingWorkspaces()"
                            size="small"
                        >
                            Désélectionner tous les groupes
                        </v-btn>
                    </v-row>
                </div>
                <v-row no-gutters class="pt-2">
                    <v-col
                        cols="12"
                        class="text-center py-3"
                        v-if="!workingFilteredAccWorkspaces.length"
                    >
                        <span>Aucun groupe de dossiers trouvé</span>
                    </v-col>
                    <template v-for="(aW, index) in workingFilteredAccWorkspaces">
                        <v-col
                            cols="6"
                            v-if="aW && !accountingWorkspacesOfUser.includes(aW.id)"
                            :key="index"
                            class="pr-2 pb-2"
                        >
                            <v-list-item
                                ripple
                                class="oss-list-item"
                                data-cy="userEdition-dossierGroup"
                                :disabled="currentUserIsSubUser"
                            >
                                <template #prepend>
                                    <v-checkbox
                                        v-model="selectedAccWorkspaces"
                                        :value="aW?.id"
                                        color="primary"
                                        :disabled="currentUserIsSubUser"
                                    />
                                </template>
                                <v-list-item-title>
                                    <span>{{ aW?.name || "XXX" }}</span>
                                </v-list-item-title>
                            </v-list-item>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </oss-dialog>

        <oss-dialog
            v-model="showAccountingFirmsDialog"
            title="Ajouter des cabinets"
            @valid="onValidateAccountingFirmDialog()"
            width="80vw"
        >
            <v-container class="selection pt-0">
                <div class="sticky-selection-header">
                    <v-row no-gutters class="py-2">
                        <v-col cols="8" class="pr-2">
                            <v-text-field-filled
                                v-model="searchAccountingFirm"
                                label="Rechercher"
                                outlined
                                hide-details
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchAccountingFirm = ''"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-btn
                            elevation="0"
                            class="mr-2"
                            rounded="xl"
                            @click="selectAllAccountingFirms()"
                            size="small"
                        >
                            Sélectionner tous les cabinets
                        </v-btn>
                        <v-btn
                            elevation="0"
                            rounded="xl"
                            @click="diselectAllAccountingFirms()"
                            size="small"
                        >
                            Désélectionner tous les cabinets
                        </v-btn>
                    </v-row>
                </div>
                <v-row no-gutters class="pt-2">
                    <v-col
                        cols="12"
                        class="text-center py-3"
                        v-if="!workingFilteredAccountingFirms.length"
                    >
                        <span>Aucun cabinet trouvé</span>
                    </v-col>

                    <template v-for="comp in workingFilteredAccountingFirms" :key="comp.id">
                        <v-col
                            v-if="!userAccountingFirmIds.includes(comp.id)"
                            cols="6"
                            class="pr-2 pb-2"
                        >
                            <v-list-item ripple class="oss-list-item" :disabled="userIsSubUser">
                                <template #prepend>
                                    <v-checkbox
                                        v-model="selectedAccountingFirms"
                                        :disabled="userIsSubUser || isParentAccountingFirm(comp.id)"
                                        :value="comp.id"
                                    />
                                </template>
                                <v-list-item-title>
                                    <span>{{
                                        comp.name +
                                        (isParentAccountingFirm(comp.id)
                                            ? " (Cabinet principale)"
                                            : "")
                                    }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ getSiretValue(comp.siret) }}
                                </v-list-item-subtitle>
                            </v-list-item>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import _ from "lodash";
import { Apollo } from "@/decorators";
import gql from "graphql-tag";
import { UserBase } from "./UserBase";
import ProfileEdition from "./ProfileEdition.vue";
import AssociateEdition from "./AssociateEdition.vue";
import OssCountrySelector from "../ossComponents/OssCountrySelector.vue";

import UPSERT_COMPANY_USER from "../../graphql/user/UpsertCompanyUser.gql";

import { Component, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        ProfileEdition,
        AssociateEdition,
        OssCountrySelector,
    },
    emits: ["isValid"],
})
export class UserEdition extends UserBase {
    showClientCompaniesDialog: boolean = false;
    showOtherCompaniesDialog: boolean = false;

    get isAccountingUser() {
        return this.isAccountingFirm;
    }

    // ---------------------------------------------------
    // dossiers affectés : avalaibleCompanies management -
    // ---------------------------------------------------

    get clientCompanies() {
        if (this.accountingFirm) {
            return this.accountingFirm.clientCompanies || [];
        } else if (this.isAutonomousCompany) {
            return [this.company];
        }
        return [];
    }

    get filteredClientCompanies() {
        const connectedUserAvailableCompanies = this.clientCompanies;
        if (this.searchCompany !== "") {
            return connectedUserAvailableCompanies
                .filter((x) => x.name.toLowerCase().includes(this.searchCompany.toLowerCase()))
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        return connectedUserAvailableCompanies.sort((a, b) => a.name.localeCompare(b.name));
    }

    openClientCompaniesDialog() {
        this.diselectAllCompany(); // Reset list
        this.selectedClientCompanies = JSON.parse(
            JSON.stringify(this.user.availableCompanies || []),
        );
        this.showClientCompaniesDialog = true;
    }

    onValidateCompaniesDialog() {
        this.user.availableCompanies = JSON.parse(JSON.stringify(this.selectedClientCompanies));
        // await this.upsert()
        this.showClientCompaniesDialog = false;
    }

    //
    // orther company
    //
    myOtherCompanies = [];
    selectedOtherCompanies = [];

    onOtherCompanyClicked(companyUser) {
        companyUser.partOfCompany = !companyUser.partOfCompany;
    }

    isAlreadyOtherCompany(companyId): boolean {
        const companyUser = this.myOtherCompanies.find((cu) => cu.company.id === companyId);
        if (companyUser) {
            return companyUser.partOfCompany;
        }
        return false;
    }

    openOtherClientCompaniesDialog() {
        this.diselectAllCompany(); // Reset list
        this.selectedOtherCompanies = [];
        this.showOtherCompaniesDialog = true;
    }

    onValidateOtherCompaniesDialog() {
        // this.user.availableCompanies = JSON.parse(JSON.stringify(this.selectedClientCompanies));
        // await this.upsert()
        for (const newOtherCompany of this.selectedOtherCompanies) {
            let companyUser = this.user.companyUsers.find(
                (cu) => cu.company.id === newOtherCompany.id,
            );

            if (!companyUser) {
                companyUser = this.myOtherCompanies.find(
                    (cu) => cu.company.id === newOtherCompany.id,
                );
            }
            if (companyUser) {
                companyUser.partOfCompany = true;
            } else {
                if (!companyUser) {
                    companyUser = {
                        id: "",
                        partOfCompany: true,
                        company: newOtherCompany,
                    };
                }
            }
            if (!this.myOtherCompanies.find((cu) => cu.company.id === newOtherCompany.id)) {
                this.myOtherCompanies.push(companyUser);
            }
        }
        this.selectedOtherCompanies = [];
        this.showOtherCompaniesDialog = false;
    }

    updateOtherCompanies() {
        this.myOtherCompanies = [];
        if (this.user.companyUsers?.length) {
            for (const companyUser of this.user.companyUsers) {
                if (companyUser.partOfCompany) {
                    this.myOtherCompanies.push(companyUser);
                }
            }
        }
    }

    async upsertOtherCompanies() {
        const promises = [];
        for (const otherCompany of this.myOtherCompanies) {
            promises.push(
                this.$apollo.mutate({
                    mutation: UPSERT_COMPANY_USER,
                    variables: {
                        id: otherCompany.id,
                        companyId: otherCompany.company.id,
                        userId: this.user.id,
                        partOfCompany: otherCompany.partOfCompany,
                    },
                }),
            );
        }
        await Promise.all(promises);
    }

    /**
     * Modifications are done in this list. The original filteredClientCompanies is preserved until, the database is hit
     */
    get workingFilteredClientCompanies() {
        const newSortedList = JSON.parse(JSON.stringify(this.filteredClientCompanies)); //.sort((compB, compA) => Number(!!this.hasRight(compA) && !!this.isAvailableCompanies(compA.id)) - Number(!!this.hasRight(compB) && !!this.isAvailableCompanies(compB.id)) )
        return newSortedList;
    }

    onCompanySelectFromMainList(company) {
        // In the main list, that is, not in the dialog
        if (company && this.hasRight(company)) {
            const index = this.selectedClientCompanies.findIndex((c) => c.id === company.id);
            if (index !== -1) {
                this.selectedClientCompanies.splice(index, 1);
            } else {
                this.selectedClientCompanies.push(company);
            }
            const removalIdx = this.selectedClientCompaniesForRemoval.findIndex(
                (c) => c.id === company.id,
            );
            if (removalIdx !== -1) {
                this.selectedClientCompaniesForRemoval.splice(removalIdx, 1);
            } else {
                this.selectedClientCompaniesForRemoval.push(company);
            }
            if (this.isAvailableCompanies(company.id)) {
                this.user.availableCompanies = this.user.availableCompanies.filter(
                    (x) => x.id !== company.id,
                );
            } else {
                const selectedCompany = this.clientCompanies?.find((x) => x.id === company.id);
                this.user.availableCompanies.push(selectedCompany);
            }
        }
    }

    //
    // doublon from UserBase
    //
    // selectAllCompany() {
    //     this.selectedClientCompanies = [
    //         ...this.workingFilteredClientCompanies.filter((comp) => this.hasRight(comp)),
    //     ];
    // }

    //
    // from UserEdition
    //
    selectAllCompany() {
        const availableCompanies = [];
        for (const company of this.clientCompanies) {
            if (
                !this.hasRight(company) &&
                !this.user?.availableCompanies?.find((ac) => ac.id === company.id)
            ) {
                continue;
            }
            availableCompanies.push(company);
        }
        this.user.availableCompanies = JSON.parse(JSON.stringify(availableCompanies));
    }

    selectedClientCompanies = [];
    selectedClientCompaniesForRemoval = []; // Companies selected in the main list for removal are stored here until processing

    get mySelectedCompanies() {
        // Companies unchecked in the main list remain visible
        return this.filteredClientCompanies.filter(
            (comp) =>
                this.hasRight(comp) &&
                (this.isCompanySelectedForRemoval(comp) || this.isAvailableCompanies(comp.id)),
        );
    }

    toggleClientCompanySelection(company) {
        if (company && this.hasRight(company)) {
            const index = this.selectedClientCompanies.findIndex((c) => c.id === company.id);
            if (index === -1) {
                this.selectedClientCompanies.push(company);
            } else {
                this.selectedClientCompanies.splice(index, 1);
            }
        }
    }

    isCompanySelectedForRemoval(company) {
        // Compnay is in the removal list
        return this.selectedClientCompaniesForRemoval.find((c) => c.id === company?.id);
    }

    isCompanySelected(company) {
        if (!company) {
            return false;
        }
        return this.selectedClientCompanies.find((c) => c.id === company.id);
    }

    //
    // doublon from UserBase
    //
    // diselectAllCompany() {
    //     if (
    //         this.isAccountingCurrentUser &&
    //         this.user.company &&
    //         this.$store.state.user.company.id === this.user.company.id
    //     ) {
    //         const availableCompanies = [];
    //         for (const company of this.user.availableCompanies) {
    //             if (!this.hasRight(company)) {
    //                 availableCompanies.push(company);
    //             }
    //         }
    //         this.selectedClientCompanies = [...availableCompanies];
    //     } else {
    //         this.selectedClientCompanies = [{ ...this.user.company }];
    //     }
    // }

    //
    // from UserEdition
    //
    diselectAllCompany() {
        if (
            this.isAccountingCurrentUser &&
            this.user.company &&
            this.$store.state.user.company.id === this.user.company.id
        ) {
            const availableCompanies = [];
            for (const company of this.user.availableCompanies) {
                if (!this.hasRight(company)) {
                    availableCompanies.push(company);
                }
            }
            this.selectedClientCompanies = availableCompanies;
        } else {
            this.selectedClientCompanies = [{ ...this.user.company }];
        }
    }

    // ------------
    // workspaces -
    // ------------
    showAccWorkspacesDialog = false;
    selectedAccWorkspaces = []; // List of Workspace ids
    selectedAccWorkspacesForRemoval = []; // Companies selected in the main list for removal are stored here until processing

    get enableWorkspace() {
        return this.accountingFirm?.clientUserAccessRight === "AVAILABLE_WORKSPACE";
    }

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    accountingWorkspaces {
                        id
                        name
                        clientCompanies {
                            id
                            name
                        }
                        users {
                            id
                            firstname
                            lastname
                            marriedName
                        }
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.accountingFirm.id,
            };
        },
        skip() {
            return !this.accountingFirm?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.company) {
                    if (data.company.accountingWorkspaces) {
                        this.accountingWorkspaces = data.company.accountingWorkspaces;

                        if (this.accountingWorkspaces.length) {
                            this.accountingWorkspaces.forEach((accountingWorkspace) => {
                                if (
                                    accountingWorkspace.users.some(
                                        (user) => user.id === this.userId,
                                    )
                                ) {
                                    this.accountingWorkspacesOfUser.push(accountingWorkspace.id);
                                }
                            });
                        }
                    } else {
                        this.accountingWorkspaces = [];
                    }
                }
            }
        },
    })
    accountingWorkspaces: any = [];

    get filteredAccountingWorkspaces() {
        // let filteredAccountingWorkspaces = []

        // debugger

        // if (this.accountingWorkspaces) {
        //     for (const aW of this.accountingWorkspaces) {
        //         filteredAccountingWorkspaces.push(aW)
        //     }
        // }

        // if (this.searchAccountingWorkspace === "") {
        //     return this.accountingWorkspaces.sort((a, b) => a.name.localeCompare(b.name));
        // } else {
        //     return this.accountingWorkspaces
        //         .filter(x => x.name.toLowerCase().includes(this.searchAccountingWorkspace.toLowerCase()))
        //         .sort((a, b) => a.name.localeCompare(b.name));
        // }
        if (!this.accountingWorkspaces) {
            return [];
        }
        if (!this.searchAccountingWorkspace) {
            return this.accountingWorkspaces.sort((a, b) => a.name.localeCompare(b.name));
        }
        const filteredAccountingWorkspaces = [];
        const searchAccountingWorkspace = this.searchAccountingWorkspace.toLowerCase();
        for (const accountingWorkspace of this.accountingWorkspaces) {
            if (accountingWorkspace.name?.toLowerCase().indexOf(searchAccountingWorkspace) !== -1) {
                filteredAccountingWorkspaces.push(accountingWorkspace);
            }
        }
        return filteredAccountingWorkspaces.sort((a, b) => a.name.localeCompare(b.name));
    }

    get mySelectedAccWorkspaces() {
        // Workspaces unchecked in the main list remain visible
        return this.filteredAccountingWorkspaces.filter(
            (aW) =>
                this.accountingWorkspacesOfUser.includes(aW.id) ||
                this.isWorkspaceSelectedForRemoval(aW.id),
        );
    }

    /**
     * Modifications are done in this list. The original filteredAccountingWorkspaces is preserved until the database is hit
     */
    get workingFilteredAccWorkspaces() {
        const wList = JSON.parse(JSON.stringify(this.filteredAccountingWorkspaces));
        return wList;
    }

    openAccWorkspacesDialog() {
        this.diselectAllAccountingWorkspaces(); // Reset list
        this.selectedAccWorkspaces = [...this.accountingWorkspacesOfUser];
        this.showAccWorkspacesDialog = true;
    }

    //
    // doublon fron UserBase
    //
    // selectAllAccountingWorkspaces() {
    //     this.accountingWorkspacesOfUser = this.accountingWorkspaces.map((af) => af.id);
    // }

    //
    // from UserEdition
    //
    selectAllAccountingWorkspaces() {
        this.selectedAccWorkspaces = this.workingFilteredAccWorkspaces.map((aW) => aW.id);
    }

    //
    // doublon fron UserBase
    //
    // diselectAllAccountingWorkspaces() {
    //     this.accountingWorkspacesOfUser = [];
    // }
    //
    // from UserEdition
    //
    diselectAllAccountingWorkspaces() {
        this.selectedAccWorkspaces = [];
    }

    isWorkspaceSelectedForRemoval(wsId) {
        // Compnay is in the removal list
        return this.selectedAccWorkspacesForRemoval.find((aWId) => aWId === wsId);
    }

    onWorkspaceSelectFromMainList(wId) {
        this.selectedAccWorkspaces = [...this.accountingWorkspacesOfUser];
        if (
            !this.accountingWorkspacesOfUser.includes(wId) &&
            !this.selectedAccWorkspacesForRemoval.includes(wId)
        ) {
            // Ajout à la liste des suppressions
            this.selectedAccWorkspacesForRemoval.push(wId);
        } else if (
            this.accountingWorkspacesOfUser.includes(wId) &&
            this.selectedAccWorkspacesForRemoval.includes(wId)
        ) {
            // Suppression de la liste des suppressions
            const index = this.selectedAccWorkspacesForRemoval.findIndex((x) => x === wId);
            if (index !== -1) {
                this.selectedAccWorkspacesForRemoval.splice(index, 1);
            }
        } else {
            console.warn(`Cas non prévu pour wId: ${wId}`);
        }
    }

    async onValidateAccWorkspacesDialog() {
        this.accountingWorkspacesOfUser = [...this.selectedAccWorkspaces];
        // await this.upsert()
        this.showAccWorkspacesDialog = false;
    }

    // -----------------
    // accountingfirms -
    // -----------------
    showAccountingFirmsDialog = false;
    selectedAccountingFirms = []; // List of accounting firms ids
    selectedAccountingFirmsForRemoval = []; // Accounting firms selected in the main list for removal are stored here until processing

    get parentAccountingFirm() {
        if (this.accountingFirm) {
            if (this.accountingFirm.isAccountingFirmOf) {
                return this.accountingFirm.isAccountingFirmOf;
            }
            return this.accountingFirm;
        }
        return null;
    }

    get accountingFirms() {
        if (this.parentAccountingFirm) {
            const accountingFirms = [];
            if (this.accountingFirm) {
                accountingFirms.push(this.accountingFirm);
            }
            if (this.parentAccountingFirm.accountingFirms?.length) {
                accountingFirms.push(...this.parentAccountingFirm.accountingFirms);
            }
            return accountingFirms;
        }
        return [];
    }

    get filteredAccountingFirms() {
        const filteredAccountingFirms = [];

        if (this.accountingFirms) {
            // On push toutes les accountingFirms du cabinet
            for (const aF of this.accountingFirms) {
                filteredAccountingFirms.push(aF);
            }
        }

        if (this.searchAccountingFirm !== "") {
            return filteredAccountingFirms
                .filter((x) =>
                    x.name.toLowerCase().includes(this.searchAccountingFirm.toLowerCase()),
                )
                .sort((a, b) => a.name.localeCompare(b.name));
        }

        return filteredAccountingFirms.sort((a, b) => a.name.localeCompare(b.name));
    }

    // bobbee expert
    get isAccountingFirm() {
        return !!this.accountingFirms.find((af) => af.id === this.companyId);
    }

    isParentAccountingFirm(accountingFirmId) {
        if (!this.parentAccountingFirm?.id) {
            return false;
        }
        return this.parentAccountingFirm.id === accountingFirmId;
    }

    @Apollo({
        query: gql`
            query AccountingFirm($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    accountingFirm
                    accountingFirms {
                        id
                        name
                        siret
                    }
                    isAccountingFirmOf {
                        id
                        name
                        siret
                        accountingFirms {
                            id
                            name
                            siret
                        }
                    }
                    clientCompanies {
                        id
                        name
                        siret
                        companyUsers {
                            id
                            user {
                                id
                                firstname
                                lastname
                            }
                            role
                        }
                    }
                    clientUserAccessRight
                }
            }
        `,
        variables() {
            return { id: this.accountingFirmId };
        },
        skip() {
            return !this.accountingFirmId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.company && data.company) {
                    this.accountingFirm = data.company;
                } else {
                    this.accountingFirm = null;
                }
            }
        },
    })
    accountingFirm = null;

    get mySelectedAccountingFirms() {
        // Accounting firms unchecked in the main list remain visible
        return this.filteredAccountingFirms.filter(
            (firm) =>
                this.userAccountingFirmIds.includes(firm.id) ||
                this.isAccountingFirmSelectedForRemoval(firm.id),
        );
    }

    /**
     * Modifications are done in this list. The original filteredAccountingFirms is preserved until the database is hit
     */
    get workingFilteredAccountingFirms() {
        debugger;
        const fList = JSON.parse(JSON.stringify(this.filteredAccountingFirms));
        return fList;
    }

    openAccountingFirmsDialog() {
        this.diselectAllAccountingFirms(); // Reset list
        this.selectedAccountingFirms = [...this.userAccountingFirmIds];
        this.showAccountingFirmsDialog = true;
    }

    isAccountingFirmSelectedForRemoval(firmId) {
        // Compnay is in the removal list
        return this.selectedAccountingFirmsForRemoval.find((x) => x === firmId);
    }

    onAccountingFirmSelectFromMainList(firmId) {
        this.selectedAccountingFirms = [...this.userAccountingFirmIds];
        if (
            !this.userAccountingFirmIds.includes(firmId) &&
            !this.selectedAccountingFirmsForRemoval.includes(firmId)
        ) {
            // Ajout à la liste des suppressions
            this.selectedAccountingFirmsForRemoval.push(firmId);
        } else if (
            this.userAccountingFirmIds.includes(firmId) &&
            this.selectedAccountingFirmsForRemoval.includes(firmId)
        ) {
            // Suppression de la liste des suppressions
            const index = this.selectedAccountingFirmsForRemoval.findIndex((x) => x === firmId);
            if (index !== -1) {
                this.selectedAccountingFirmsForRemoval.splice(index, 1);
            }
        } else {
            console.warn(`Cas non prévu pour firmId: ${firmId}`);
        }
    }

    async onValidateAccountingFirmDialog() {
        this.userAccountingFirmIds = [...this.selectedAccountingFirms];
        // await this.upsert()
        this.showAccountingFirmsDialog = false;
    }

    //
    // doublon from UserBase
    //
    // selectAllAccountingFirms() {
    //     if (!this.currentUserIsSubUser) {
    //         this.userAccountingFirmIds = this.accountingFirms.map((af) => af.id);
    //     }
    // }

    // fron UserEdition
    selectAllAccountingFirms() {
        if (!this.currentUserIsSubUser) {
            this.selectedAccountingFirms = this.workingFilteredAccountingFirms.map(
                (firm) => firm.id,
            );
        }
    }
    //
    // doublon from UserBase
    //
    // diselectAllAccountingFirms() {
    //     if (!this.currentUserIsSubUser) {
    //         this.userAccountingFirmIds = [];
    //     }
    // }
    //
    // from UserEdition
    //
    diselectAllAccountingFirms() {
        if (!this.currentUserIsSubUser) {
            this.selectedAccountingFirms = [];
        }
    }

    // ----------------
    // companySetting -
    // ----------------
    companySettingDialog = false;
    companySettingSelectedId = "";

    async setCompanySettings(company) {
        // if (!this.hasRight(company)) {
        //     return;
        // }
        this.companySettingSelectedId = company.id;
        this.companySettingDialog = true;
    }

    get titleCompanySetting() {
        if (this.companySettingSelected) {
            return (
                "Rôle de " +
                this.getUserDisplayName(this.user) +
                " dans la société " +
                this.companySettingSelected.name
            );
        }
        return "//";
    }

    get companySettingSelected() {
        if (this.companySettingSelectedId) {
            return this.filteredClientCompanies.find((x) => x.id === this.companySettingSelectedId);
        }
        return "";
    }

    //
    // reset
    //

    reset() {
        super.reset();
        this.selectedClientCompaniesForRemoval = []; // Reset companies unselected in main list
        this.selectedAccWorkspacesForRemoval = []; // Reset unselected workspaces in main list
        this.selectedAccountingFirmsForRemoval = []; // Reset unselected workspaces in main list
    }
}

export default toNative(UserEdition);
</script>
<style scoped>
.selection .sticky-selection-header {
    position: sticky !important;
    z-index: 2 !important;
    top: 0 !important;
    /* height: 100px !important;  */
    width: 100% !important;
    background-color: white !important;
    box-sizing: border-box !important;
}

.selection {
    position: relative !important;
}
</style>
